// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  pricingBenefits: {
    name: 'pricingBenefitsPage',
    componentName: 'PricingPageWrapper',
    chunk: () =>
      import(
        /* webpackChunkName: "PricingPageWrapper" */
        './pages/PricingPageWrapper'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/PricingPageWrapper.tsx'),
          ).PricingPageWrapper
        : currentRouteName === 'pricingBenefitsPage'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.PricingPageWrapper,
            })),
          );
    },
    path: '/:context?/myaccount/proXtraPricing',
    channel: null,
  },
  perks: {
    name: 'perksPage',
    componentName: 'PerksPage',
    chunk: () =>
      import(
        /* webpackChunkName: "pricingBenefitsPage" */
        './pages/PerksPage'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/PerksPage.tsx'),
          ).PerksPage
        : currentRouteName === 'perksPage'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.PerksPage,
            })),
          );
    },
    path: '/:context?/myaccount/proXtraPerks',
    channel: null,
  },
  rewardsHub: {
    name: 'rewardsHubPage',
    componentName: 'RewardsHubPage',
    chunk: () =>
      import(
        /* webpackChunkName: "rewardsHubPage" */
        './pages/RewardsHubPage'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/RewardsHubPage.tsx'),
          ).RewardsHubPage
        : currentRouteName === 'rewardsHubPage'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.RewardsHubPage,
            })),
          );
    },
    path: '/:context?/myaccount/proXtraRewards',
    channel: null,
  },
});
